import type { Vocabulary } from '@/api/types';

export const VOCAB_LABEL: Record<Vocabulary, string> = {
  interest: 'Interests',
  subject: 'Subjects',
  format: 'Format',
  style: 'Style',
  energy: 'Energy level',
  educational_value: 'Educational values',
  genre: 'Genres',
  parent_objective: 'Parent objectives',
};
